import React from 'react';
import { Divider } from 'antd';
import { useCollection } from 'react-firebase-hooks/firestore';

import Client from 'containers/app/client';

import LoadingFullPage from 'components/loading-full-page';
import { LayoutPage } from 'components/layouts';

import WorkersWidget from './workers-widget';
import EmployersWidget from './employers-widget';
import OrganizationsWidget from './organizations-widget';
import TokenRequestsWidget from './token-requests-widget';
import AdminInvitesWidget from './admin-invites-widget';
import BookingRequestWidget from './booking-request-widget';
import BookingsWidget from './bookings-widget';
import WorkerConnectionWidget from './worker-connection-widget';

import './style.css';

const Panel = () => {
  const refUsers = Client.db.collection('users');
  const [collectionUsers, loadingUsers, errorUsers] = useCollection(refUsers);

  const refOrganizations = Client.db.collection('organizations');
  const [
    collectionOrganizations,
    loadingOrganizations,
    errorOrganizations,
  ] = useCollection(refOrganizations);

  if (loadingUsers || loadingOrganizations) return <LoadingFullPage />;
  if (errorUsers) throw new Error(errorUsers);
  if (errorOrganizations) throw new Error(errorOrganizations);

  const users = collectionUsers.docs.map((doc) => {
    return { ...doc.data(), id: doc.id, key: doc.id };
  });

  const organizations = collectionOrganizations.docs.map((doc) => {
    return { ...doc.data(), id: doc.id, key: doc.id };
  });

  return (
    <LayoutPage className="dashboard-page">
      <LayoutPage.Container className="wrapper">
        <h1>Admin panel</h1>
        <Divider />
        <WorkersWidget users={users} organizations={organizations} />
        <EmployersWidget users={users} organizations={organizations} />
        <OrganizationsWidget users={users} organizations={organizations} />
        <AdminInvitesWidget organizations={organizations} />
        <WorkerConnectionWidget users={users} />
        <BookingRequestWidget users={users} />
        <BookingsWidget users={users} />
        <TokenRequestsWidget users={users} />
      </LayoutPage.Container>
    </LayoutPage>
  );
};

export default Panel;
